const OAUTH_PENDING_RETURN_KEY = "skyhire_oauth_pending_return";
const OAUTH_CALLBACK_STATUS_KEY = "skyhire_oauth_callback_status";

interface OAuthPendingReturn {
  path: string;
  timestamp: number;
}

interface OAuthCallbackStatus {
  status: "success" | "error";
  message?: string;
  timestamp: number;
}

export function storeOAuthReturnPath(path: string): void {
  const data: OAuthPendingReturn = {
    path,
    timestamp: Date.now(),
  };
  localStorage.setItem(OAUTH_PENDING_RETURN_KEY, JSON.stringify(data));
}

export function captureOAuthCallbackStatus(): void {
  const urlParams = new URLSearchParams(window.location.search);
  const oauthStatus = urlParams.get("oauth");

  if (oauthStatus === "success" || oauthStatus === "error") {
    const data: OAuthCallbackStatus = {
      status: oauthStatus,
      message: urlParams.get("message") || undefined,
      timestamp: Date.now(),
    };
    localStorage.setItem(OAUTH_CALLBACK_STATUS_KEY, JSON.stringify(data));
  }
}

export function getAndClearOAuthReturnPath(): {
  path: string;
  oauthStatus?: OAuthCallbackStatus;
} | null {
  try {
    const stored = localStorage.getItem(OAUTH_PENDING_RETURN_KEY);
    if (!stored) {
      localStorage.removeItem(OAUTH_CALLBACK_STATUS_KEY);
      return null;
    }

    const data: OAuthPendingReturn = JSON.parse(stored);
    localStorage.removeItem(OAUTH_PENDING_RETURN_KEY);

    const maxAge = 10 * 60 * 1000;
    if (Date.now() - data.timestamp > maxAge) {
      localStorage.removeItem(OAUTH_CALLBACK_STATUS_KEY);
      return null;
    }

    let oauthStatus: OAuthCallbackStatus | undefined;
    const statusStored = localStorage.getItem(OAUTH_CALLBACK_STATUS_KEY);
    if (statusStored) {
      oauthStatus = JSON.parse(statusStored);
      localStorage.removeItem(OAUTH_CALLBACK_STATUS_KEY);
    }

    return { path: data.path, oauthStatus };
  } catch {
    localStorage.removeItem(OAUTH_PENDING_RETURN_KEY);
    localStorage.removeItem(OAUTH_CALLBACK_STATUS_KEY);
    return null;
  }
}
